import * as Config from '../config';
import React, { useCallback, useEffect} from 'react';
import { connect } from "react-redux";
import { setModal, setAuth, setAuthResponse, setUser, setStoreAuth, setSubscription } from "../actions/index";
import './library/onboarding/Log.css'

import Welcome from './library/custom/-APP_TARGET/mods/modal/Welcome';
import LinkModal from './library/custom/-APP_TARGET/content/LinkModal';
import LinkPro from './library/custom/-APP_TARGET/content//LinkPro';
import ModalCTA from './library/modal/ModalCTA';
import ModalButton from './library/modal/ModalButton';

/* Store Auth Management */
function ConnectedLogWrapper({
  setAuth, setAuthResponse, setUser, setModal, setStoreAuth, isConnected,
}) {
  // const navigate = useNavigate();

  // Custom Modal Link Subscription
  const link = useCallback((underlayClickExits = true) => {
    setModal({
      content: <LinkModal />,
      underlayClickExits
    })
  }, [setModal]);

  // Custom Modal Link Pro Subscription
  const linkPro = useCallback(() => {
    setModal({
      content: <LinkPro />,
      underlayClickExits: true
    })
  }, [setModal]);

  const registration = useCallback((underlayClickExits = true) => {
    const clientID = Config.API_CLIENT_ID; //v2
    const uri = `${window.location.origin}/new-account`;
    window.open(`${Config.API_IDENTITY_URL}/register?response_type=code&client_id=${clientID}&redirect_uri=${uri}`, `_self`);
  }, []);

  const signupPM = useCallback(() => {
    const showRegistration = () => {
      setTimeout(() => { registration() }, 500);
    }
    setModal({
      content: (
        <ModalCTA
          title={'Join the set'}
          description={'Create your free Beatport account to send requests, chat, and save playlists.'}
          styleContainer={{marginTop: `-60%`, marginLeft: `-5%`}}
          styleBody={{ gap: 16 }}
          styleDescription={{ marginBottom: 16 }}
          classModal={`bottom-reduce`}
        >
        <ModalButton label={`Sign up`} onClick={showRegistration} />
        <ModalButton label={`Close`} className={`cancel`} />
        </ModalCTA>
      )
    });
  }, [setModal, registration]);

  // V2 - PKCE
  const signin = useCallback(async () => {
    const clientID = Config.API_CLIENT_ID; //v2
    const PKCE = await Config.generatePKCE();
    sessionStorage.setItem("pkce_verifier", PKCE.code_verifier);
    const uri = (window.location.origin.includes('localhost')) ? `${window.location.origin}/` : `${window.location.origin}/home`;
    window.open(`${Config.API_IDENTITY_URL}/o/authorize/?response_type=code&client_id=${clientID}&redirect_uri=${uri}&code_challenge=${PKCE.code_challenge}&code_challenge_method=S256`, `_self`); 
  }, []);

  // V2 - Custom Modal Welcome DJ APP
  const welcome = useCallback((underlayClickExits = null) => {
    const isNew = !localStorage.getItem('fl');
    if (isNew && Config.ONBOARDING) {
      setModal({
        content: <Welcome />,
        underlayClickExits: (underlayClickExits === null) ? Config.FREEMIUM : underlayClickExits
      })
    } else {
      signin();
    }
  }, [setModal, signin]);

  const logout = useCallback(() => {
    if (isConnected) {
      localStorage.removeItem('expired');
      localStorage.removeItem('cQfdJ@gD8yjHqr'); // USERID
      sessionStorage.clear();
      setAuth({ token: null });
      setAuthResponse(null);
      setUser(null);
      setSubscription(false);

      // Logout Identity Service V2
      const uri = `${window.location.origin}/home`;
      window.location.href = `${Config.API_IDENTITY_URL}/identity/v1/logout/?callbackUrl=${uri}/`;
    }
  }, [ setAuth, setAuthResponse, setUser, isConnected]);

  useEffect(() => {
    setStoreAuth({ signin, logout, welcome, link, linkPro, registration, signupPM })
  }, [setStoreAuth, signin, logout, welcome, link, linkPro, registration, signupPM])

  return null;
}

const LogWrapper = connect(
  state => ({
    isConnected: state.isConnected
  }),
  dispatch => ({
    setModal: content => dispatch(setModal(content)),
    setAuth: (form) => dispatch(setAuth(form)),
    setUser: data => dispatch(setUser(data)),
    setAuthResponse: state => dispatch(setAuthResponse(state)),
    setStoreAuth: store => dispatch(setStoreAuth(store)),
    setSubscription: state => dispatch(setSubscription(state))
  })
)(ConnectedLogWrapper);

export default LogWrapper;
